import { ReactNode } from 'react';

import { Stack, Typography, tokens } from '@cast/design-system';

type TooltipErrorProps = {
  title: string;
  error: ReactNode;
};

export const TooltipError = ({ title, error }: TooltipErrorProps) => {
  return (
    <Stack gap={8}>
      <Typography variant="P12R">{title}</Typography>
      <Typography
        variant="C12"
        lineHeight="18px"
        component="p"
        sx={{
          position: 'relative',
          backgroundColor: tokens.theme.bg.structural.code,
          color: tokens.theme.fg.structural.primaryOnInverse,
          pr: 10,
          pl: 20,
          '&:before': {
            content: '""',
            position: 'absolute',
            left: 10,
            top: 2,
            bottom: 2,
            width: 3,
            borderRadius: '10px',
            backgroundColor: tokens.theme.data.red400,
          },
        }}
      >
        {error}
      </Typography>
    </Stack>
  );
};
